import React, { useMemo, useState, useEffect } from "react";

import { useParams } from "react-router-dom";

import { NoServices } from "../components/Errors";
import useUpdateQueryParams from "../hooks/useUpdateQueryParams";

import ProfilingPageTitle from "./components/ProfilingPageTitle";
import ItemSkeleton from "./services/item/ItemSkeleton";
import ServiceList from "./services/ServiceList";
import { ApplicationListType, ApplicationType } from "./type";
import { useServiceList } from "./util";
import ProfilingWrapper from "./widget/ProfilingWrapper";
import WidgetApp from "./widget/WidgetApp";

/**
 * Check if the selected app and profile combination exist
 */
const selectedParamsExist = (params: any, apps?: ApplicationListType) => {
  const name = params.get("app");
  const profile = params.get("profile");
  const app = apps?.[name];
  if (app) {
    const isProfile =
      app.profile_types && Object.keys(app.profile_types).includes(profile);
    return { profile: isProfile ? profile : undefined, app };
  }
  return { profile, app: { name } };
};

const Profiling = () => {
  const params = useParams();
  const [app, setApp] = useState<ApplicationType>({
    name: params?.appName || ""
  });

  const { serviceList, error: serviceError } = useServiceList();

  useUpdateQueryParams({ app: app?.name }, false);

  const searchParams = new URLSearchParams(window.location.search);
  const paramApp = selectedParamsExist(searchParams);
  const selectedApp = app || paramApp.app;
  const appName = selectedApp?.name;

  const errors: any = serviceError;
  const hasService = serviceList.app.length && !serviceError;

  useEffect(() => {
    if (params.appName) {
      setApp({ name: params.appName });
    }
  }, [params.appName]);

  const renderWidget = () => {
    return (
      <ProfilingWrapper app={selectedApp} profile={paramApp.profile}>
        <WidgetApp
          onviewApp={app => setApp(app || { name: "" })}
          appService={appService}
        />
      </ProfilingWrapper>
    );
  };

  const appService = useMemo(
    () =>
      Object.values(serviceList)
        .flat()
        .find(service => service.name === selectedApp?.name),
    [selectedApp?.name, serviceList]
  );

  return appName && !errors ? (
    renderWidget()
  ) : (
    <div>
      <ProfilingPageTitle />
      {hasService ? (
        <ServiceList
          serviceList={serviceList}
          onViewApp={application => setApp(application || { name: "" })}
        />
      ) : serviceError ? (
        <NoServices />
      ) : (
        <ItemSkeleton />
      )}
    </div>
  );
};

export default Profiling;
